module.exports = __webpack_public_path__ + "e0106718/img/ion_calendar-number.3ac5bd07.svg";